import TemplatesDelete from './TemplatesDelete'

export default TemplatesDelete
